module.exports = __webpack_public_path__ + "img/contact_a05.4fafc58e.png";